import {
    API,
  } from '@/vue-plugins/api';
  
  const o = {
    namespaced: true,
  };
  
  o.state = {
    cached:{}
  };
  
  o.getters = {
    
  };
  
  
  o.actions = {
    load({commit, state}, {id,view='editor'}) {
      return new Promise((resolve)=>{
        if (state.cached[id] && state.cached[id][view]) {
          resolve(state.cached[id][view]);
        } else {
          API.get(`models/${id}?view=${view}`).then((res)=>{
            commit('save', {id,view,def:res.data.data});
            resolve(res.data.data);
          });
        }
      });
    },
   
  };
  
  o.mutations = {
    save(state, model) {
        if(!model.id) {
            return;
        }
        if(state.cached[model.id]) {
            state.cached[model.id][model.view] = model.def;
        }else{
            state.cached[model.id] = {
                [model.view]: model.def
            }
        }
    },
  };
  
  export default o;
  